<div class="templeteC">

    @if(_templateData.header){
    <div style="text-align: center;">
        <h1 style="margin-bottom: 0.05em;">{{_templateData.header.title}}</h1>
        <h3 style="margin-top: 0.05em;">{{_templateData.header.subTitle}}</h3>
        <div>
            @for(line of _templateData.header.lineItems; track line){
            {{line}}<br>
            }
        </div>
    </div>
    <br>
    }

    @if (_templateData.bodyText) {
    <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
        <div style="width: 75vw;" [innerHtml]="safeHtmlBody"></div>
    </div>
    <br>
    }

    <div style="display: flex;  flex-wrap: wrap; justify-content: center; align-items: stretch; width: 100%;">

        <mat-card style="min-width: 350px; margin: 5px;">
            <mat-card-header>
                <div mat-card-avatar>
                    <mat-icon>info</mat-icon>
                </div>
                <mat-card-title>Information Request</mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>

                <form [formGroup]="informationRequestFormGroup" (ngSubmit)="onSubmit()">
                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name" placeholder="First & Last name">
                    </mat-form-field>
                    <br>
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" placeholder="name@example.com">
                    </mat-form-field>
                    <br>
                    <mat-form-field style="width: 100%;">
                        <mat-label>What would you like to ask us?</mat-label>
                        <mat-select formControlName="questions" multiple>
                            <mat-select-trigger>
                                {{informationRequestFormGroup.valid ?
                                'Click submit below' : 'Fill in your name and email address' }}
                            </mat-select-trigger>
                            @for (question of sectionList; track question) {
                            <mat-option [value]="question">{{question.question}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <br>
                    <button mat-raised-button [disabled]="!informationRequestFormGroup.valid">Submit</button>
                </form>

            </mat-card-content>

        </mat-card>

        <mat-card style="min-width: 350px; margin: 5px;">
            <mat-card-header>
                <div mat-card-avatar>
                    <mat-icon>map</mat-icon>
                </div>
                <mat-card-title>Directions</mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
                <div [innerHtml]="iframe"></div>
            </mat-card-content>

            <mat-card-actions>

            </mat-card-actions>
        </mat-card>
    </div>
</div>